/*
    * Vuetify default settings
*/
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.css';
import en from '../language/Common/en';
import es from '../language/Common/es';
import fr from '../language/Common/fr';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            light: {
                primary: '#19719e',
                accent: '#19719e'
            }
        }
    },
    lang: {
       locales: {
            en,
            es,
            fr
       },
       current: 'en'
    }
});
